import { Component } from 'react';
const defaultErrorBoundaryState = { error: undefined };
/**
 * Renders the wrapped component until an error is thrown. When an error is
 * thrown in the child component, the fallback component will be rendered.
 */
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = defaultErrorBoundaryState;
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, info) {
        var _a, _b;
        (_b = (_a = this.props).onError) === null || _b === void 0 ? void 0 : _b.call(_a, error, info);
    }
    render() {
        return this.state.error ? this.props.fallback : this.props.children;
    }
}
//# sourceMappingURL=error-boundary.js.map